import { NgModule } from '@angular/core';
import { FuseSharedModule } from './../../../../@fuse/shared.module';
import { ChatPanelModule } from './../../components/chat-panel/chat-panel.module';
import { ContentModule } from './../../components/content/content.module';
import { FooterModule } from './../../components/footer/footer.module';
import { NavbarModule } from './../../components/navbar/navbar.module';
import { QuickPanelModule } from './../../components/quick-panel/quick-panel.module';
import { ToolbarModule } from './../../components/toolbar/toolbar.module';
import { VerticalLayout3Component } from './../../vertical/layout-3/layout-3.component';
import { SidePanelModule } from '../../components/side-panel-dynamic/side-panel.module';
import { FuseSidebarModule } from '../../../../@fuse/components/sidebar/sidebar.module';
import { PlatformBreadCrumbModule } from '../../../../../app-platform-breadcrumb';
import { PlatformBreadcrumbSharedModule } from '../../../../../app-platform-breadcrumb-shared-module';

@NgModule({
    declarations: [VerticalLayout3Component],
    imports: [
        // RouterModule,
        FuseSharedModule,
        FuseSidebarModule,
        ChatPanelModule,
        ContentModule,
        FooterModule,
        NavbarModule,
        QuickPanelModule,
        SidePanelModule,
        ToolbarModule,
        PlatformBreadCrumbModule,
        PlatformBreadcrumbSharedModule
    ],
    exports: [VerticalLayout3Component]
})
export class VerticalLayout3Module {}
